import styles from './styles.module.css';

import { useTranslation } from 'react-i18next';
import LangMenu from 'src/components/LangMenu/LangMenu';


const Footer = () => {
    const { t } = useTranslation("common");


    return (
        <section className={styles.footer}>
            <div className="container">
                <div className={styles.copyright}>
                    <div>{t("footer.copyright")}</div>
                </div>
            </div>
        </section>
    );
};

export default Footer;
